import { log } from 'log';

import * as Types from './types';
import { TDeviceFormFactor } from 'js/hooks/device/store/types';

export const parseComponentConfig = <TConfig>(
    formFactor: TDeviceFormFactor,
    config: TConfig | string | undefined,
    parseConfig: Types.TParseConfig
) => {
    let parsedConfig = null;
    let platformConfig = null;

    if (typeof config === 'string' && config.length) {
        try {
            parsedConfig = JSON.parse(config.replaceAll('\'', '"'));
            platformConfig = parsedConfig[formFactor as keyof TConfig];
        } catch (e) {
            log('error', 'can\'t parse component config');
        }
    }

    return parseConfig(platformConfig || parsedConfig || config || {});
};
